const SUBMISSION_SEQUENCE_STORAGE_KEY = 'welya.live-api-submission-sequence';

type SequenceStorage = Pick<Storage, 'getItem' | 'setItem'>;

/**
 * Séquence d'une soumission sondage/quiz envoyée à live-api : le consumer ignore une séquence qui ne
 * dépasse pas la dernière appliquée. Elle part de l'horloge et de la dernière séquence envoyée par ce
 * navigateur, conservée d'un rechargement à l'autre : une horloge qui recule ne la fait pas reculer.
 */
export function nextSubmissionSequence(previous: number, now: number): number {
  return Math.max(Math.floor(now), previous + 1);
}

export function readStoredSubmissionSequence(storage: SequenceStorage | null): number {
  try {
    const stored = Number(storage?.getItem(SUBMISSION_SEQUENCE_STORAGE_KEY));
    return Number.isSafeInteger(stored) && stored > 0 ? stored : 0;
  } catch {
    return 0;
  }
}

export function storeSubmissionSequence(storage: SequenceStorage | null, sequence: number): void {
  try {
    storage?.setItem(SUBMISSION_SEQUENCE_STORAGE_KEY, String(sequence));
  } catch {
    // stockage indisponible : la séquence reste croissante pour la visite en cours
  }
}
